import { createQueryOptions } from "@packages/core-client/api/createQueryOptions.ts";
import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useCompanyClient } from "../../api/queries/company.ts";

const COMPANY_TAB_ID = "company";

export function useIsCompanyTabHidden() {
    const { queryUtils } = useCompanyClient();
    const { data } = useQuery(createQueryOptions(queryUtils.getCompanyProfile.queryOptions(), { throwOnError: false }));

    const isVisible = !!(data?.isOrganizationAdmin || data?.mission || (data?.values && data.values.length > 0));

    return useCallback(
        (tabId: string) => {
            if (tabId === COMPANY_TAB_ID) {
                return !isVisible;
            }

            return false;
        },
        [isVisible]
    );
}
